import { useContext, useState } from 'react';
import { Grid, Typography, makeStyles, Button } from '@material-ui/core';
import EditSelectedDataSourceFieldsDialog from './EditSelectedDataSourceFieldsDialog';
import EditDataSpaceFormContext from '../../context/EditDataSpaceFormContext';
import removeDatasetInDataSpace from '../../../../utils/removeDatasetInDataSpace';

const useStyles = makeStyles((theme) => ({
	datasetWrapper: {
		width: '100%',
		marginBottom: '1rem',
	},
	datasetHeader: {
		margin: '0 0 0.5rem 0',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderBottom: '1px solid black',
	},
	datasetHeaderButton: {
		width: '3rem',
		textTransform: 'lowercase',
	},
	datasetField: {
		height: 'fit-content',
		marginBottom: '0.25rem',
		padding: '0.3rem',
		backgroundColor: '#393939',
		borderRadius: '0.2rem',
		boxSizing: 'border-box',
		color: '#FFFFFF',
		overflow: 'hidden',
		textAlign: 'center',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
}));

// Component showing a selected datasource name and its selected fields.
const SelectedDataset = (props) => {
	const classes = useStyles();

	const editDataSpaceFormContext = useContext(EditDataSpaceFormContext);

	const [isEditSelectedDatasetFieldsDialogOpen, setIsEditSelectedDatasetFieldsDialogOpen] = useState(false);

	const editDatasetClickHandler = () => {
		setIsEditSelectedDatasetFieldsDialogOpen(true);
	};

	const deleteDatasetClickHandler = () => {
		const updatedDataSpace = removeDatasetInDataSpace(editDataSpaceFormContext.dataSpace, props.selectedDataset._id);
		editDataSpaceFormContext.setDataSpace(updatedDataSpace);
	};

	// Only show fields that have been selected.
	const selectedFields = props.selectedDataset.fields.filter((field) =>
		editDataSpaceFormContext.dataSpace.toggledColumnsState?.find((toggledColumn) => toggledColumn === field.name),
	);
	const selectedFieldComponents = selectedFields.map((selectedField) => (
		<Grid item xs={12} sm={5.9}>
			<div className={classes.datasetField}>{selectedField.displayName || selectedField.name}</div>
		</Grid>
	));

	return (
		<>
			<div className={classes.datasetWrapper}>
				<p className={classes.datasetHeader}>
					{props.selectedDataset.displayName || props.selectedDataset.name}
					{props.selectedDataset.tags.timeFrame && ' ' + props.selectedDataset.tags.timeFrame}
					{editDataSpaceFormContext.dataSpace.datasets.some(
						(dataset) => dataset.name === props.selectedDataset.name && dataset._id !== props.selectedDataset._id,
					) && ' (' + props.selectedDataset._id.substring(21) + ')'}
					<div>
						<Button className={classes.datasetHeaderButton} onClick={editDatasetClickHandler}>
							edit
						</Button>
						<Button className={classes.datasetHeaderButton} onClick={deleteDatasetClickHandler}>
							delete
						</Button>
					</div>
				</p>
				<Grid item container xs={12} justifyContent="space-between">
					{selectedFieldComponents.length ? selectedFieldComponents : 'No fields selected'}
				</Grid>
			</div>

			{/* If user clicks "edit" on a selected datasource, render a dialog to edit its selected fields */}
			{isEditSelectedDatasetFieldsDialogOpen && (
				<EditSelectedDataSourceFieldsDialog
					dataset={props.selectedDataset}
					isEditSelectedDatasetFieldsDialogOpen={isEditSelectedDatasetFieldsDialogOpen}
					setIsEditSelectedDatasetFieldsDialogOpen={setIsEditSelectedDatasetFieldsDialogOpen}
				/>
			)}
		</>
	);
};

export default SelectedDataset;
